import { StackedColumnChart } from "components/Common"
import { getStatusInstrument } from "helpers/fakebackend_helper"
import { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import { withTranslation } from "react-i18next"
import { statusInstrument as statusInstrumentData } from "common/data/statusInstrument"



const BodyMidTop = ({ t, statusInstruments }) => {
  const [statusInstrument, setStatusInstrument] = useState([])
  const [insId, setInsId] = useState([])
  const [dataStatusInstruments, setDataStatusInstruments] = useState([])

  useEffect(() => {
    setDataStatusInstruments(statusInstruments.length > 0 ? statusInstruments : statusInstrumentData)
  }, [statusInstruments])

  const onFetchStatusInstrument = async () => {

    let statusIns = []
    let value = []
    let ins = []


    dataStatusInstruments.map(item => {
      value = []
      item.instruments.map(val => {
        value.push(val.value)
        ins.push(val.instrumentName)
      })
      statusIns.push({
        name: t(item.label),
        data: value,
      })
    })
    setStatusInstrument(statusIns)
    setInsId(ins)
  }


  useEffect(() => {
    onFetchStatusInstrument()
  }, [dataStatusInstruments])

  return (
    <Col lg="12">
      <Card className="mb-2" style={{ height: 'fit-content' }}>
        <CardHeader
          style={{
            textAlign: "center",
            background: "#fff",
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 600 }}>Trạng thái máy</div>
        </CardHeader>
        <CardBody style={{ paddingTop: 0, paddingBottom: 0 }}>
          <Nav
            pills
            className="navtab-bg"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
          </Nav>
          <TabContent
            activeTab={"1"}
            className="p-3 text-muted"
          >
            <TabPane tabId="1">
              <Row>
                <Col sm="12" style={{ padding: 0 }}>
                  <StackedColumnChart
                    periodData={statusInstrument}
                    dataColors={[
                      "--bs-primary",
                      "--bs-warning",
                      "--bs-success",
                    ]}
                    categories={insId}
                    height={237}
                  />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </Col>
  )
}

export default withTranslation(["generalDashboard", "message"])(BodyMidTop)
